export const PROVINCES = [
  "Onbekend / n.v.t.",
  "Drenthe",
  "Flevoland",
  "Friesland",
  "Gelderland",
  "Groningen",
  "Limburg",
  "Noord-Brabant",
  "Noord-Holland",
  "Overijssel",
  "Utrecht",
  "Zeeland",
  "Zuid-Holland",
  "België / Vlaanderen",
  "Anders",
];

export const LANGUAGES = [
  "Nederlands",
  "Oud-Nederlands",
  "Engels",
  "Frans",
  "Duits",
  "Anders",
];

export const SAMPLES = [
  {
    id: "oorlogsbrief-1918",
    title: "Oorlogsbrief (1918)",
    year: "1918",
    region: "Gelderland",
    url: "https://static.prod-images.emergentagent.com/jobs/6947acc3-96d8-4494-b4a1-a5455aa06179/images/32b10aae709cdc05546f0127c976a88b8b0397742620e9840b332629bf4499a2.jpeg",
  },
  {
    id: "notariele-akte-1882",
    title: "Notariële Akte (1882)",
    year: "1882",
    region: "Zuid-Holland",
    url: "https://static.prod-images.emergentagent.com/jobs/6947acc3-96d8-4494-b4a1-a5455aa06179/images/5dfa003b8fc3143d785007d0c4877284ca7cf2acb9cd8741d899a6c40133e12a.jpeg",
  },
  {
    id: "familiebrief-1953",
    title: "Familiebrief (1953)",
    year: "1953",
    region: "Zeeland",
    url: "https://static.prod-images.emergentagent.com/jobs/6947acc3-96d8-4494-b4a1-a5455aa06179/images/7beda8098b66be5fbd48b232ccca5a288cd9f6ecd31102c52b3c949e6eca1ede.jpeg",
  },
  {
    id: "moeilijke-brief-1891",
    title: "Vervaagde brief (1891)",
    year: "1891",
    region: "Noord-Holland",
    url: "https://static.prod-images.emergentagent.com/jobs/6947acc3-96d8-4494-b4a1-a5455aa06179/images/38254d99b13337275094e6f057595c67c344b52b1af3bb9a8324c8732137eee0.jpeg",
  },
];

export const DOC_TYPES = [
  { value: "handgeschreven", label: "Handgeschreven brief", icon: "PenLine" },
  { value: "getypt", label: "Getypte brief", icon: "Keyboard" },
  { value: "ansichtkaart", label: "Ansichtkaart", icon: "Image" },
  { value: "telegram", label: "Telegram", icon: "Zap" },
  { value: "briefpapier", label: "Briefpapier (met gedrukte kop)", icon: "FileText" },
];

export const DOC_TYPE_LABEL = Object.fromEntries(DOC_TYPES.map((d) => [d.value, d.label]));
export const DOC_TYPE_ICON = Object.fromEntries(DOC_TYPES.map((d) => [d.value, d.icon]));

